import { Link } from "react-router-dom";
import "./product.css";
// import Chart from "../../components/chart/Chart"
// import {productData} from "../../dummyData"
// import { Publish } from "@material-ui/icons";
import { useProductsContext } from "../../hooks/useProductsContext";
import { useLocation } from "react-router";
import { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase";

export default function Product() {
    const location = useLocation()
    const [image, setImage] = useState();

    const ID = location.pathname.split("/")[2]
    const {dispatch,name,setName, price, setPrice,
        color, setColor, size, setSize,stock, setStock,
        error, setError,emptyFields, setEmptyFields,update, setUpdate, url, setUrl,category, setCategory} = useProductsContext()

        const handleColorChange = (index, value) => {
          const updatedColors = [...color]; // Create a copy of the colors array
          updatedColors[index] = value; // Update the color value at the specified index
          setColor(updatedColors); // Update the colors state
        };
      
        const handleAddColor = () => {
          setColor([...color, '']);
         
          // Add an empty string to the colors array
        };
      

    const handleSubmit = async (e) => {
        e.preventDefault()

        const imageRef = ref(storage, `products/${image.name}`);
        await uploadBytes(imageRef, image).then(() => {
            getDownloadURL(imageRef).then( (downloadURL) => {
            setUrl(downloadURL);
            console.log("URL", url);
            
          })})
      
        const product = {name, price, color,size,category,stock,url}

    const response = await fetch(`https://fashionforwardd.azurewebsites.net/api/products/${ID}`,{
        method:'PATCH',
        headers: {
          'Content-Type': 'application/json',
      
        },
        body: JSON.stringify(product)
    })
      const json = await response.json()
    //   console.log("JSON", json)

    if(response.ok) {
     
        setName('')
        setPrice('')
        setColor('')
        setSize('')
        setStock('')
        setUrl('')
        setCategory('')
        setError(null)
        setEmptyFields([])
      console.log("Product updated", json)
     //   dispatch({type:'UPDATE_WORKOUT',json})
      }
      if(!response.ok) {
        setError(json.error)
       // setEmptyFields(json.emptyFields)
    }
 }
 
        return (
    <div className="product">
      <div className="productTitleContainer">
        <h1 className="productTitle">Product</h1>
        <Link to="/newproduct">
          <button className="productAddButton">Create</button>
        </Link>
      </div>
    
      <div className="productBottom">
          <form className="productForm" onSubmit={handleSubmit}>
              <div className="productFormLeft">
             
                  <label>Product Name</label>
                  <input type="text" 
          value={name} onChange={(e) => setName(e.target.value)}  />
          
          <label>Price</label>
          <input type="number" 
          value={price} onChange={(e) => setPrice(e.target.value)} />
     
     <div className="addProductItem">
        <label>Colors</label>
       
      {color && color.map((color, index) => (
        <input
          key={index}
          type="text"
          placeholder="Product color"
          value={color}
          id="colors"
          required
          onChange={(e) => handleColorChange(index, e.target.value)}
        />
      ))}
 
      <button type="button" onClick={handleAddColor}>Add more color</button>

         
        </div>
     
    
          <label>Size</label>
          <input type="text"
          value={size} onChange={(e) => setSize(e.target.value)} />
  
     
          <label>Stock</label>
          <input type="number" 
          value={stock} onChange={(e) => setStock(e.target.value)} />
     <label>Category</label>
          <select name="category" id="category" required onChange={(e) => setCategory(e.target.value)}>
            <option value="men">Men</option>
            <option value="women">Women</option>
            <option value="accessories">Accessories</option>
          </select>

          <label>Image</label>
          <input type="file" id="file" onChange={(e)=>{setImage(e.target.files[0])}} />
   

              </div>
              <div className="productFormRight">
                  {/* <div className="productUpload">
                      <img src="https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt="" className="productUploadImg" />
                      <label for="file">
                          <Publish/>
                      </label>
                      <input type="file" id="file" style={{display:"none"}} />
                  </div> */}
                  <button className="productButton">Update</button>
              </div>
          </form>
      </div>
    </div>
  );
}
